import i18next, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";

export const createTestI18n = (resources?: Resource, lng = "hu") => {
  const i18n = i18next.createInstance();
  i18n.use(initReactI18next).init({
    lng,
    fallbackLng: "en",
    resources: resources ?? {
      hu: { translation: {} },
      en: { translation: {} },
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    returnNull: false,
  });
  return i18n;
};

export const i18nTest = createTestI18n();

export const setTestTranslations = (
  lng: string,
  dict: Record<string, string>,
  ns = "translation",
) => {
  i18nTest.addResourceBundle(lng, ns, dict, true, true);
  i18nTest.changeLanguage(lng);
};
